<ukg-ignite-shell
  theme="modern"
  useLatestCdn="true"
  enableCdnPath="true"
  rebrand="true">
  <!-- User Display in Header -->
  @if (currentUser$ | async; as user) {
    <div slot="user" class="user-display">
      <span class="user-name">{{ getUserDisplayName(user) }}</span>
      <div class="user-avatar">
        <span class="avatar-initials">{{ getUserInitials(user) }}</span>
      </div>
    </div>
  }

  <router-outlet></router-outlet>
</ukg-ignite-shell>
